import SectionHeading from '@/components/base/SectionHeading';
import { rankItems } from '@/mocks/homeData';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-accent-600',
  down: 'ri-arrow-down-line text-primary-600',
  new: 'ri-sparkling-line text-secondary-600',
};

export default function RankSection() {
  const maxHeat = Math.max(...rankItems.map((item) => item.heat));

  return (
    <section id="rank" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-10">
        <SectionHeading
          eyebrow="Weekly Heat Rank"
          title="本周对线热度榜：哪些实锤被反复引用"
          description="热度按引用次数、评论量与二次整理量综合计算，每天更新一次。榜上条目都可以直接跳回对应的证据卡片核对。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 rounded-lg border border-background-200/70 bg-background-100/60 overflow-hidden">
            <div className="flex items-center justify-between gap-3 px-4 md:px-6 py-4 border-b border-background-200/70 bg-background-50">
              <span className="text-sm font-medium text-foreground-950">实锤证据榜</span>
              <span className="text-xs text-foreground-500 flex items-center gap-1">
                <i className="ri-refresh-line" />
                更新于 09-09 08:00
              </span>
            </div>
            <ul>
              {rankItems.map((item) => (
                <li
                  key={item.id}
                  className="px-4 md:px-6 py-4 border-b border-background-200/60 last:border-b-0 flex items-center gap-4 cursor-pointer hover:bg-background-50 transition-colors"
                >
                  <span
                    className={`w-8 h-8 shrink-0 rounded-md flex items-center justify-center text-sm font-semibold ${
                      item.rank <= 3
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm md:text-base font-medium text-foreground-950 truncate">
                      {item.title}
                    </p>
                    <div className="mt-2 h-1.5 w-full max-w-md rounded-full bg-background-200 overflow-hidden">
                      <span
                        className="block h-full rounded-full bg-accent-400"
                        style={{ width: `${Math.round((item.heat / maxHeat) * 100)}%` }}
                      />
                    </div>
                  </div>
                  <div className="shrink-0 text-right">
                    <p className="text-sm font-semibold text-foreground-950">
                      {item.heat.toLocaleString()}
                    </p>
                    <p className={`text-xs flex items-center justify-end gap-1 ${trendIcon[item.trend]}`}>
                      <i className={trendIcon[item.trend].split(' ')[0]} />
                      {item.delta}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <aside className="lg:col-span-4 flex flex-col gap-4">
            <div className="rounded-lg border border-background-200/70 bg-background-100/60 p-5">
              <h3 className="text-base font-semibold text-foreground-950">证据类型分布</h3>
              <ul className="mt-4 flex flex-col gap-4">
                {[
                  { label: '截图链', value: 38, tone: 'bg-primary-500' },
                  { label: '聊天记录', value: 24, tone: 'bg-primary-700' },
                  { label: '录音原件', value: 15, tone: 'bg-secondary-500' },
                  { label: '视频实拍', value: 12, tone: 'bg-accent-500' },
                  { label: '文件解析', value: 11, tone: 'bg-secondary-700' },
                ].map((row) => (
                  <li key={row.label} className="flex items-center gap-3">
                    <span className="w-20 shrink-0 text-xs text-foreground-600">{row.label}</span>
                    <span className="flex-1 h-2 rounded-full bg-background-200 overflow-hidden">
                      <span
                        className={`block h-full rounded-full ${row.tone}`}
                        style={{ width: `${row.value * 2.4}%` }}
                      />
                    </span>
                    <span className="w-9 text-right text-xs text-foreground-600">{row.value}%</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-primary-200 bg-primary-100/60 p-5">
              <span className="text-xs tracking-[0.2em] text-primary-700">归档提醒</span>
              <p className="mt-3 text-base font-semibold text-foreground-950">
                证据被删了，这里还有一份
              </p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                入库内容会保留原始分辨率与哈希值，二次整理只新增副本，不覆盖旧档。需要回看某一天的记录，直接按日期翻时间线锤即可。
              </p>
              <a
                href="#timeline"
                className="mt-4 inline-flex items-center gap-2 text-sm text-primary-700 hover:text-primary-800 cursor-pointer whitespace-nowrap"
              >
                去翻时间线锤
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}